import { z } from 'my-zod'
import { vehicleBillingPlanEnum, vehiclesModel } from '../vehicle'
import { ProgramTypeEnum } from '../../internal'
import { customAssetFamilyModel } from '../custom-asset-family'
import { customAssetClassModel } from '../custom-asset-class'

export const customAssetView = vehiclesModel
  .pick({
    id: true,
    shortId: true,
    operatorId: true,
    outfitterCustomAssetSerialNumber: true,
    lifecycleStatus: true,
    lastModifiedDate: true,
    serverLastModifiedDate: true,
    deletedDate: true
  })
  .augment({
    customAssetFamilyId: z
      .number({
        invalid_type_error: 'Asset Family is required',
        required_error: 'Asset Family is required'
      })
      .positive('Asset Family is required'),
    operatorUnitNumber: z
      .string({
        invalid_type_error: 'Outfitter Unit Number is required',
        required_error: 'Outfitter Unit Number is required'
      })
      .min(1, 'Outfitter Unit Number must contain at least 1 character')
      .max(25, 'Outfitter Unit Number must contain at most 25 characters')
      .setLabel('Outfitter Unit Number'),
    vehicleImei: z
      .string()
      .min(15, 'IMEI must contain 15 digits')
      .max(15, 'IMEI must contain 15 digits')
      .refine((value) => /^[0-9]+$/.test(value), {
        message: 'IMEI must contain 15 digits'
      })
      .nullable()
      .setLabel('Custom Asset IMEI'),
    programType: z.literal(ProgramTypeEnum.Values.PolarisAdventures),
    billingPlan: z.literal(vehicleBillingPlanEnum.Values['Not Adv Owned']),
    landingPageEnabled: z.literal(false),
    assetFamilyName: customAssetFamilyModel.shape.name.setLabel('Asset Family'),
    assetClassName: customAssetClassModel.shape.name.setLabel('Asset Class'),
    assetClassId: customAssetClassModel.shape.id
  })

export type customAssetView = z.infer<typeof customAssetView>
